export default __webpack_public_path__ + "static/media/mountain.6443acb5.jpg";